import { Skeleton } from "@/components/ui/skeleton";

export const OrderFormSkeleton = () => (
  <div className="bg-card rounded-2xl shadow-card p-4 sm:p-6 border border-border/50 space-y-4">
    <div className="flex items-center gap-2 mb-2">
      <Skeleton className="w-5 h-5 rounded" />
      <Skeleton className="h-5 w-40" />
    </div>
    {/* Category tabs */}
    <div className="flex gap-2 overflow-hidden">
      {[1, 2, 3, 4].map(i => (
        <Skeleton key={i} className="h-8 w-20 rounded-lg shrink-0" />
      ))}
    </div>
    {/* Device grid */}
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {[1, 2, 3, 4, 5, 6].map(i => (
        <Skeleton key={i} className="h-10 rounded-lg" />
      ))}
    </div>
    {/* Variant selectors */}
    <Skeleton className="h-10 w-full rounded-lg" />
    <Skeleton className="h-10 w-full rounded-lg" />
    {/* Price area */}
    <div className="flex justify-between items-center pt-2">
      <Skeleton className="h-6 w-28" />
      <Skeleton className="h-10 w-32 rounded-lg" />
    </div>
  </div>
);

export const FaqSkeleton = () => (
  <div className="bg-card rounded-2xl shadow-card p-4 sm:p-6 border border-border/50 space-y-3">
    <div className="flex items-center gap-2 mb-1">
      <Skeleton className="w-4 h-4 rounded" />
      <Skeleton className="h-5 w-52" />
    </div>
    {[1, 2, 3, 4].map(i => (
      <div key={i} className="flex items-center justify-between py-3 border-b border-border/30 last:border-0">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="w-4 h-4 rounded" />
      </div>
    ))}
  </div>
);

export const ReviewsSkeleton = () => (
  <div className="bg-card rounded-2xl shadow-card p-4 sm:p-6 border border-border/50 space-y-3">
    <div className="flex items-center gap-2 mb-2">
      <Skeleton className="w-4 h-4 rounded" />
      <Skeleton className="h-5 w-36" />
    </div>
    <div className="flex gap-3 overflow-hidden">
      {[1, 2, 3].map(i => (
        <div key={i} className="shrink-0 w-48 space-y-2 p-3 border border-border/30 rounded-xl">
          <div className="flex items-center gap-2">
            <Skeleton className="w-8 h-8 rounded-full" />
            <div className="space-y-1">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-2.5 w-14" />
            </div>
          </div>
          <Skeleton className="h-16 w-full rounded-lg" />
          <Skeleton className="h-2.5 w-full" />
          <Skeleton className="h-2.5 w-2/3" />
        </div>
      ))}
    </div>
  </div>
);
